<div class="position-relative">
  <h2 id="browserCompatibilityTitle">Browser Compatibility</h2>
  <button type="button" id="closeBtn" class="close" aria-label="Close" mat-button mat-dialog-close>
    <img src="./assets/close_side_nav.png">
  </button>
  TCS Enterprise Manager is compatible with the following browsers:
  <br><br>
  <ul class="list-group">
    <li class="list-group-item ">Microsoft Edge 100+</li>
    <li class="list-group-item"> Mozilla Firefox 98+</li>
    <li class="list-group-item"> Google Chrome 100+</li>
    <li class="list-group-item"> Safari iOS 12+</li>

  </ul>
  <br>
  This site is best viewed in 1366x768 resolution.
</div>
